<template>
  <a :href="link" target="_blank" class="my-page-news-story">
    <div class="img">
      <img v-if="image" class="image" :src="image.url" :alt="image.alt" />
      <div v-else class="image">
        <!-- fallback -->
      </div>
    </div>
    <div class="content">
      <h3 v-html="title"></h3>
      <div class="date text-secondary">
        <i class="budicon-calendar mr-2"></i>
        {{ formattedDate }}
      </div>
      <div v-html="excerpt"></div>
    </div>
  </a>
</template>

<script>
import moment from 'moment';

export default {
  name: 'MyPageNewsStory',

  props: {
    title: String,
    date: String,
    excerpt: String,
    image: Object,
    link: String,
  },

  computed: {
    formattedDate() {
      return moment.utc(this.date).format('DD.MM.YYYY');
    },
  },
};
</script>

<style scoped lang="scss">
.my-page-news-story {
  background: white;
  border: 1px solid $gray-300;
  border-radius: $border-radius;
  cursor: pointer;
  color: inherit;

  h3 {
    font-size: 1.25rem;
  }
}

.image {
  width: 100%;
  max-height: 140px;
  background: $gray-200;
  object-fit: cover;
  border-top-left-radius: $border-radius;
  border-top-right-radius: $border-radius;
}

.content {
  padding: 1rem;
}

.date {
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
}
</style>
